import { LoginCallback } from '@okta/okta-react';
import { Link, useLocation } from 'react-router-dom';

/**
 * Wraps Okta's `<LoginCallback />` and intercepts the `?error=...` case.
 *
 * When Okta redirects back with an error (e.g. user cancelled, invalid
 * redirect URI, unauthorized client) the default `<LoginCallback />` throws,
 * which bubbles into React's error boundary and looks like a crash. Render
 * a friendly error card instead and let the user navigate home to retry.
 */
const LoginCallbackHandler = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const error = params.get('error');
  const errorDescription = params.get('error_description');

  if (error) {
    return (
      <div className="login-callback-error">
        <div
          className="alert alert-danger"
          role="alert"
          style={{ maxWidth: 520, margin: '4rem auto' }}
        >
          <h4 className="alert-heading">Sign-in failed</h4>
          <p>
            <strong>{error}</strong>
          </p>
          {errorDescription && <p>{errorDescription}</p>}
          <hr />
          <p className="mb-0">
            <Link to="/">Return home</Link> and try again.
          </p>
        </div>
      </div>
    );
  }

  return <LoginCallback />;
};

export default LoginCallbackHandler;
